import {
  AdditionalInterest,
  AdditionalInterestType,
} from "@covertree/new-business-graphql";

/** Display order of the interests on a policy. */
const interestOrder = [
  AdditionalInterestType.Lienholder,
  AdditionalInterestType.HomeownersAssociation,
  AdditionalInterestType.GovernmentMunicipality,
  AdditionalInterestType.PropertyManagerParkOwner,
  AdditionalInterestType.NotListed,
];

/** Billing party first, then by type. Leaves the input untouched. */
export const sortAdditionalInterests = (
  additionalInterests: AdditionalInterest[]
): AdditionalInterest[] =>
  [...additionalInterests].sort((a, b) => {
    if (a.isBilling) return -1;
    if (b.isBilling) return 1;

    return (
      interestOrder.indexOf(a.type as AdditionalInterestType) -
      interestOrder.indexOf(b.type as AdditionalInterestType)
    );
  });

/** Feeds the per-type caps in the form validator. */
export const countInterestsByType = (
  additionalInterests: readonly { type?: string | null }[]
): Record<AdditionalInterestType, number> =>
  additionalInterests.reduce(
    (counts, interest) => {
      const type = interest.type as AdditionalInterestType;
      counts[type] = (counts[type] || 0) + 1;
      return counts;
    },
    {} as Record<AdditionalInterestType, number>
  );
